export default __webpack_public_path__ + "static/media/pending-status.b76adb3e.svg";